import { useClearAnnouncements } from "@src/components/live-announcer";
import { useCallback } from "react";
import { toast } from "react-toastify";

export function useClearSessionMessages() {
  const clearAnnouncements = useClearAnnouncements();

  return useCallback(() => {
    toast.clearWaitingQueue();
    toast.dismiss();
    clearAnnouncements();
  }, [clearAnnouncements]);
}
